module.exports = __webpack_public_path__ + "img/kk-instagram.e3988e91.png";